<template>
  <div>
    <div v-if="showModal">
      <aha-modal
        id="ahaDonationPromoModal"
        ref="ahaDonationPromoModal"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        size="lg"
        hide-footer
        hide-header
        centered
        lazy
      >
        <b-container fluid>
          <b-row>
            <div class="l-generic__col col-md-12 p-0">
              <div
                class="c-promotion__card h-theme--black h-text-contrast mb-0"
              >
                <div
                  class="c-article-card__background h-placeholder-image"
                  :class="{
                    'h-placeholder-image--16-9': translations.image,
                  }"
                >
                  <img
                    v-if="translations.image"
                    :src="translations.image"
                    v-lazy-img="translations.image"
                    alt=""
                  />
                  <b-embed
                    v-else
                    type="iframe"
                    aspect="16by9"
                    :src="translations.video"
                    allowfullscreen
                  ></b-embed>
                  <b-btn-close
                    class="c-modal--promotion__close btn btn-dark"
                    @click="handleClose"
                    >×</b-btn-close
                  >
                </div>
              </div>
            </div>
          </b-row>
          <b-row align-v="center">
            <div class="col-lg-12 c-promotion__title__wrapper w-100 px-0">
              <div
                id="dialog-title"
                class="c-promotion__title w-100 text-center mb-3"
                v-html="translations.title"
              ></div>
            </div>
            <div class="d-flex c-promotion__modal" :class="{ 'flex-wrap': translations.btn2 }">
              <div class="">
                <div
                  class="h4 text-lg-left text-center"
                  id="dialog-description"
                  v-html="translations.description"
                ></div>
              </div>
              <div class="mx-auto mt-3 c-promotion__modal-buttons">
                <a
                  :href="translations.url"
                  class="mb-lg-0 mb-3 mr-lg-5 mr-0 btn btn-lg btn-round btn-danger" :class="{ 'btn-outline-primary' : btnColor }"
                  :data-tracking="dataTracking"
                  >{{ translations.btn }}</a
                >
                <a v-if="translations.btn2"
                  :href="translations.url2"
                  class="btn btn-lg ml-lg-5 ml-0 btn-round btn-danger" :class="{ 'btn-outline-primary': btnColor2 }" 
                  :data-tracking="dataTracking"
                  >{{ translations.btn2 }}</a>
              </div>
            </div>
          </b-row>
        </b-container>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isVisible: false,
      btnColor: true,
      btnColor2: false
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 0,
    },
    translations: {
      type: Object,
      required: true,
      default: {
        btn: "Donate",
        url: "",
        title: "",
        description: "",
        image: null,
        video: null,
      },
    },
    endpoint: {
      type: String,
      required: true,
    },
    dataTracking: {
      type: String,
    },
  },
  mounted() {
    if (this.interval !== 0) {
      this.timeTrigger();
    } else if (this.$refs.ahaDonationPromoModal == null) {
      return false;
    } else {
      this.$refs.ahaDonationPromoModal.show();
    }

    if(this.translations.btnTheme == 'red'){
      this.btnColor = false
    } else {
      this.btnColor = true
    }

    if(this.translations.btnTheme2 == 'white'){
      this.btnColor2 = true
    } else {
      this.btnColor2 = false
    }

    console.log("Data Tracking");
    console.log(this.dataTracking);
  },
  methods: {
    handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaDonationPromoModal");
      //this.$refs.ahaDonationPromoModal.show();
    },
    hideModal() {
      this.$refs.ahaDonationPromoModal.hide();
    },
    onShown() {
      this.isVisible = true;
    },
    onHidden() {
      this.isVisible = false;
    },
    timeTrigger() {
      setTimeout(() => {
        this.$refs.ahaDonationPromoModal.show();
      }, this.interval * 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-donation-modal.vue